'use strict';

import '../proto/Window-getViewportDimensions';
import '../proto/Window-getScrollPosition';
import '../proto/Element-getPosition';
/*
 * scrollBreakpoint::addBreakpoint 
 * @public 
 * @desc add standalone Breakpoint (when no passed when instantiate class)
 * @params (object) params {
 *		breakpoint: @int|@Element|@NodeList
 *		callBack: @object {
 *			UP: optional callable callback when scrolling up
 *			DOWN: optional callable callback when scrolling down
 *		}
 * }
 * 
 */

const directions = {
	UP: 'UP',
	DOWN: 'DOWN'
};

 
export default class ScrollBreakpoint {
	/*
	 * @constructor 
	 * @params (arrayOf(@object)) breakpoints (optional) : {
	 *		breakpoint: @int|@Element|@NodeList
	 *		callBack: @object {
	 *			UP: optional callable callback when scrolling up
	 *			DOWN: optional callable callback when scrolling down
	 *		}
	 * }
	 * 
	 */
	constructor(breakpoints) {
		const _this = this;
		this.currentValues = window.getScrollPosition();
		this.callBacks = [];
		
		
		if( Array.isArray(breakpoints) ) {
			this.breakpoints = breakpoints;
		
			this.breakpoints.forEach((breakpoint, index) => {
				if(breakpoint.hasOwnProperty('breakpoint') && breakpoint.hasOwnProperty('callBack'))
					this._addCallBack(index);
			});
		}
		else 
			this.breakpoints = [];

		window.addEventListener('scroll', () => {
			_this._onScroll(false);
		});
		this._onScroll(true);
	};
	
	
	
	/*
	 * ScrollBreakpoint::addBreakpoint 
	 * @public 
	 * @desc add standalone Breakpoint (when no passed when instantiate class)
	 * @params (object) params {
	 *		breakpoint: @int|@Element|@NodeList
	 *		callBack: @object {
	 *			UP: optional callable callback when scrolling up
	 *			DOWN: optional callable callback when scrolling down
	 *		}
	 * }
	 * 
	 */
	addBreakpoint(params) {
		this.breakpoints.push(params);
		const index = this.breakpoints.length - 1;
		const addedParams = this._addCallBack(index);
		
		
		const scroll = window.getScrollPosition();
		// if scroll > scrollValue && isset callbacks.DOWN
		
		addedParams.forEach( p => {
			if( scroll.y > p.scrollValue && params.callBack.hasOwnProperty('DOWN')) {
				params.callBack.DOWN.call(p);
			}
			else if( scroll.y < p.scrollValue && params.callBack.hasOwnProperty('UP'))
				params.callBack.UP.call(p);
		});
	}
	
	
	
	/*
	 * ScrollBreakpoint::_addCallback 
	 * @private 
	 * @desc Construct an array of object foreach action 
	 * @params (int) index — the index in the configuration breakpoint array
	 * Built object is like 
	 * - @int scrollValue: the value that be triggered
	 * - @int index; the index in the configuration breakpoint array (-1 to disable)
	 * - @Element element (optional): the element that must be passed to the callback func
	 */
	_addCallBack(index) {
		const _this = this;
		const bp = this.breakpoints[index];
		const offsetY = 150;
		const viewportHeight = window.getViewportDimensions().height;
		const p = [];
		
		if( bp.breakpoint instanceof Element ) {
			p.push({
				scrollValue: bp.breakpoint.getPosition().top - (viewportHeight - offsetY),
				index: index,
				element: bp.breakpoint,
			});
			this.callBacks.push(p[0]);
			return p;
		}
		
		if( bp.breakpoint instanceof NodeList ) {
			bp.breakpoint.forEach(el => {
				const obj = {
					scrollValue: el.getPosition().top - (viewportHeight - offsetY),
					index: index,
					element: el,
				};
				p.push(obj);
				_this.callBacks.push(obj);
			});
			return p;
		}
	
		
		p.push({
			scrollValue: parseInt(bp.breakpoint, 10),
			index: index,
			element: undefined,
		});
		
		this.callBacks.push(p[0]);
		return p;
	}
		

	

	
	_onScroll(force) {
		const values = window.getScrollPosition();
		
		/*
		if( values.y === this.currentValues.y )
			return;
		*/	
		const _this = this;
		const direction = values.y < this.currentValues.y ? directions.UP : directions.DOWN;
		
		this.callBacks.forEach( (params, index) => {
			if( params.index === -1 ) {
				return;
			}
			
			if(! _this.breakpoints[params.index].callBack.hasOwnProperty(direction)) {
				return;
			}
			
			const isGoDownAndMustApply = direction === directions.DOWN && (values.y >= params.scrollValue)  && ((_this.currentValues.y < params.scrollValue) || force);
			const isGoUpAndMustApply = direction === directions.UP && (values.y <= params.scrollValue) && ((_this.currentValues.y > params.scrollValue) || force);	
			if(! (isGoDownAndMustApply || isGoUpAndMustApply)) {
				return;
			}
			
			const callBacks = _this.breakpoints[params.index].callBack;
			callBacks[direction].call(params);
			
			// happen once only so remove key :-)
			if( Object.keys(callBacks).length < 2 ) {
				_this.callBacks[index].index = -1;
			}
		});
		
		this.currentValues = values;
	}
};
